import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import FleetManagementApiService from './FleetManagementApiService'
import { GET_GL_ACCOUNT_CODES, GET_GL_ACCOUNT_CODE_SAVE } from 'Store/FleetManagement/GLAccountCodes/GLAccountCodesType';
import { setGLAccountCodeSave, setGLAccountCodes } from 'Store/FleetManagement/GLAccountCodes/GLAccountCodesAction';
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';
import * as purchaseOrderActions from "redux/PurchaseOrder/action";

const errorForSavePurchaseOrder = {
    showAlert: true,
    type: "error",
    text: "Something went wrong, Please try again !!",
};

function* getGLAccountCodes(req: any): any {
    try {
        yield put(globalLoaderText("Fetching values...."));

        let payloadData: IPayload = {
            apiType: apiType.FleetManagement,
            endpoint: `fleet/dropdown/glcodes`,
            apiMethod: apiMethod.GET,
            payload: null
        }

        const response = yield call(
            FleetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        if (response) {
            yield put(setGLAccountCodes(response))
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        yield put(globalLoaderText(""));
    }
}

function* getGLAccountCodeSaveServices(req: any): any {
    try {
        yield put(globalLoaderText("Saving GL Account...."));

        let payloadData: IPayload = {
            apiType: apiType.FleetManagement,
            endpoint: `requisition/fleet/update/glaccount`,
            apiMethod: apiMethod.POST,
            payload: req.payload
        }

        const response = yield call(
            FleetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        if (response) {
            yield put(setGLAccountCodeSave(response))
            yield put(globalLoaderText(""));
        } else {
            purchaseOrderActions.setError({
                ...errorForSavePurchaseOrder,
                itemNumber: req.payload?.itemNumber,
            })
        }
    } catch (error) {
        purchaseOrderActions.setError({
            ...errorForSavePurchaseOrder,
            itemNumber: req.payload?.itemNumber,
        })
        yield put(globalLoaderText(""));
    }
}

function* watchGetSaveAdminTask() {
    yield takeEvery(GET_GL_ACCOUNT_CODES, getGLAccountCodes)
    yield takeEvery(GET_GL_ACCOUNT_CODE_SAVE, getGLAccountCodeSaveServices)
}

export default function* combinedSaga() {
    yield all([
        watchGetSaveAdminTask()
    ])
}
